// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"596":"226253c7","663":"50c0ef2e","673":"69be36c7","704":"a63f8cfd","777":"4825b896","981":"71d17f47"}[chunkId] + ".chunk.css";
};